import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const PseudoNahradyNd = {
	name: NAME,
	apiProvider,
	router,
};
